// import { useState } from 'react';

// interface YesNoInputProps {
//   disabled: boolean;
// }

// export const YesNoInput = ({ disabled }: YesNoInputProps) => {
//   const [value, setValue] = useState<'yes' | 'no' | null>(null);

//   return (
//     <div className="flex gap-3">
//       {(['yes', 'no'] as const).map((opt) => (
//         <button
//           key={opt}
//           type="button"
//           disabled={disabled}
//           onClick={() => !disabled && setValue(opt)}
//           className={`flex-1 py-2 rounded-lg border text-sm font-semibold transition-colors ${
//             value === opt
//               ? 'bg-[#C0275E] text-white border-[#C0275E]'
//               : 'bg-[#F8EFF3] text-[#621C43] border-[#C0275E] hover:bg-pink-100'
//           } disabled:cursor-default`}
//         >
//           {opt === 'yes' ? '✓ Yes' : '✗ No'}
//         </button>
//       ))}
//     </div>
//   );
// };

import { useState } from 'react';

interface YesNoInputProps {
  disabled?: boolean;
}

export const YesNoInput = ({ disabled = false }: YesNoInputProps) => {
  const [value, setValue] = useState<'yes' | 'no' | ''>('');

  return (
    <div className="w-full">
      <select
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value as 'yes' | 'no')}
        className="w-full py-2 px-3 rounded-lg border border-[#C0275E] 
                   bg-[#F8EFF3] text-[#621C43] text-sm font-semibold
                   focus:outline-none focus:ring-2 focus:ring-[#C0275E]
                   disabled:cursor-not-allowed"
      >
        <option value="" disabled>
          Select option
        </option>
        <option value="yes">✓ Yes</option>
        <option value="no">✗ No</option>
      </select>
    </div>
  );
};
